export default __webpack_public_path__ + "static/media/thumbnail1.270eccd9.jpg";